import { stateSwitch } from '../stateSwitch';
import { addUserActivityListeners, removeUserActivityListeners } from './userActivityEvents';
import { addUserLoginListener, removeUserLoginListener } from './userLoginEvents';
import { addPageVisibilityListeners, removePageVisibilityListeners } from './pageVisibilityEvents';
import { addContainerVisibilityEventListener, removeContainerVisibilityEventListener, } from './containerVisibilityEvents';
import { createItemsIntersectionObserver, addItemsVisibilityEventListeners, removeItemsVisibilityEventListeners, } from './itemsVisibilityEvents';
import { addContainerMutationEventListener, removeContainerMutationEventListener } from './containerMutationEvents';
/**
 * Adds all event listeners
 */
export var addAllListeners = function () {
    addUserActivityListeners();
    addUserLoginListener();
    addPageVisibilityListeners();
    addContainerVisibilityEventListener();
    if (stateSwitch.config.items) {
        createItemsIntersectionObserver();
        addItemsVisibilityEventListeners();
        addContainerMutationEventListener();
    }
};
/**
 * Removes all dependent event listeners
 */
export var removeAllListeners = function () {
    if (stateSwitch.config.items) {
        removeContainerMutationEventListener();
        removeItemsVisibilityEventListeners();
    }
    removeContainerVisibilityEventListener();
    removePageVisibilityListeners();
    removeUserLoginListener();
    removeUserActivityListeners();
};
